import { z } from 'zod';
import { DealActivityStatus, DealActivityEventType, DealActivityEventPriority } from '@trnsact/trnsact-shared-types';

import { dateStringSchema } from '../../model';

export const calendarEventUpdateFormSchema = z
  .object({
    subject: z.string().min(1, 'Subject is required'),
    accountId: z.string().uuid(),
    allDay: z.boolean(),
    description: z.string(),
    endAt: dateStringSchema,
    endDate: dateStringSchema,
    startAt: dateStringSchema,
    startDate: dateStringSchema,
    eventType: z.nativeEnum(DealActivityEventType),
    activityStatus: z.nativeEnum(DealActivityStatus),
    priority: z.nativeEnum(DealActivityEventPriority),
  })
  .superRefine((data, ctx) => {
    if (data.allDay) {
      if (data.startDate && data.endDate && new Date(data.endDate) < new Date(data.startDate)) {
        ctx.addIssue({ code: z.ZodIssueCode.custom, message: 'End date must be after start date', path: ['endDate'] });
      }

      return;
    }

    if (data.startAt && data.endAt && new Date(data.endAt) < new Date(data.startAt)) {
      ctx.addIssue({ code: z.ZodIssueCode.custom, message: 'End must be after start', path: ['endAt'] });
    }
  });

export type CalendarEventUpdateFormValues = z.infer<typeof calendarEventUpdateFormSchema>;
